import { createFileRoute } from '@tanstack/react-router';
// Route options stay light; the page is code-split with the component.
import { ChatPage } from '@/features/chat/pages/chat-page';

/** The Chat app: the conversations are in the list pane, this is the pane's starting point. */
export const Route = createFileRoute('/_auth/o/$orgId/chat/')({
  component: ChatRoute,
});

function ChatRoute() {
  const { orgId } = Route.useParams();
  return <ChatPage orgId={orgId} />;
}
